import { API_URL } from "../config/api";

const VISITOR_ID_KEY = "neko_visitor_id";

function getVisitorId() {
  try {
    let id = localStorage.getItem(VISITOR_ID_KEY);
    if (!id) {
      id = (crypto?.randomUUID?.() || `v_${Date.now()}_${Math.random().toString(36).slice(2)}`);
      localStorage.setItem(VISITOR_ID_KEY, id);
    }
    return id;
  } catch {
    // Private browsing / storage disabled — fall back to a per-session id.
    return `v_${Date.now()}_${Math.random().toString(36).slice(2)}`;
  }
}

function send(payload) {
  const body = JSON.stringify({ ...payload, visitorId: getVisitorId() });
  try {
    // sendBeacon survives page unloads (e.g. clicking away right after a
    // click event) and doesn't block navigation, unlike fetch.
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: "application/json" });
      navigator.sendBeacon(`${API_URL}/api/analytics`, blob);
      return;
    }
  } catch {
    // fall through to fetch
  }
  fetch(`${API_URL}/api/analytics`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body,
    keepalive: true,
  }).catch(() => {});
}

// Fire-and-forget pageview ping. Skips /admin/* so the admin's own use of
// the panel never skews the "visits" numbers being looked at right there.
export function trackPageview(path) {
  if (!path || path.startsWith("/admin")) return;
  send({ type: "pageview", path, referrer: document.referrer || "" });
}

// Fire-and-forget click ping for instrumented CTAs (e.g. the Android APK
// download button). `label` is a short, stable identifier you choose —
// not the button's visible text, so relabeling copy doesn't break stats.
export function trackClick(label, path = window.location.pathname) {
  if (path.startsWith("/admin")) return;
  send({ type: "click", path, label, referrer: document.referrer || "" });
}
